<template>
  <div id="app">
    <Buscador/>
  </div>
</template>
<script>
import Buscador from '@/components/screen/Buscador.vue'
import store from '@/store'
export default {
  components: {
    Buscador
  },
  created () {
    const HOST = window.location.hostname
    store.commit('IP', 'localhost')
    // eslint-disable-next-line
    HOST === 'localhost' ? null : store.commit('IP', HOST)
  }
}
</script>
<style scoped>
 #content {
    margin-left: 0.5vw;
    margin-right: 0.5vw
}
</style>



// WEBPACK FOOTER //
// src/App.vue